import { matchPathname, pathByRouteName } from './routes';

export const navigateToSearchPage = ({ history, location, routeConfiguration, to }) => {
  const currentRoute = matchPathname(location.pathname, routeConfiguration)[0];
  const searchPath = pathByRouteName('SearchPage', routeConfiguration);
  const isAlreadyOnSearchPage =
    currentRoute?.route?.name === 'SearchPage' || location.pathname === searchPath;

  if (typeof window !== 'undefined' && !isAlreadyOnSearchPage) {
    window.location.assign(to);
    return;
  }

  history.push(to);
};
